import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Editor, EditorTools, EditorUtils } from '@progress/kendo-react-editor';
import { fetchApi } from '../services/api';
import * as moment from 'moment';
import { Grid, GridColumn as Column, GridSortChangeEvent, GridCell, GridCellProps } from '@progress/kendo-react-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import * as $ from 'jquery';
const DocumentTitle = require('react-document-title');

const { Bold, Italic, Underline,
    AlignLeft, AlignRight, AlignCenter,
    Indent, Outdent,
    OrderedList, UnorderedList,
    Undo, Redo, Link, Unlink } = EditorTools;

type Props = RouteComponentProps<{}>;

type State = {
    MobileSubject: string;
    MobileBody: string;
    Notices: NoticeData[];
    NoticeSubject: string;
    editorHtml: string;
    sort: SortDescriptor[];
}

export interface NoticeData {
    Subject: string;
    Body: string;
    SentBy: string;
    Method: string;
    SentDate: Date;
}

export function MySubjectCell(open: (subject: string, body: string, method: string) => void) {
    return class SubjectCell extends GridCell {
        render() {
            if (this.props.dataItem.Method === 'Email') {
                return (<td><a href="#" data-toggle="modal" data-target=".notice-modal" onClick={(e) => {
                    e.preventDefault();
                    open(this.props.dataItem.Subject, this.props.dataItem.Body, this.props.dataItem.Method);
                }}>{this.props.dataItem.Subject}</a></td>);
            } else {
                return (<td><a href="#" data-toggle="modal" data-target=".mobile-modal" onClick={(e) => {
                    e.preventDefault();
                    open(this.props.dataItem.Subject, this.props.dataItem.Body, this.props.dataItem.Method);
                }}>{this.props.dataItem.Subject}</a></td>);
            }
        }
    }
}

class SentByCell extends GridCell {
    render() {
        return (<td>{this.props.dataItem.SentBy}</td>);
    }
}

class SentDateCell extends GridCell {
    render() {
        return (<td>{moment(this.props.dataItem.SentDate).format("MM/DD/YYYY hh:mm a")}</td>);
    }
}

class MethodCell extends GridCell {
    render() {
        return (<td>{this.props.dataItem.Method}</td>);
    }
}

export default class Notices extends React.Component<Props, State> {
    CommandCell: React.ComponentType<GridCellProps>;
    private editor: React.RefObject<Editor>;

    constructor(props: Props) {
        super(props);

        this.state = {
            MobileSubject: '',
            MobileBody: '',
            Notices: [],
            NoticeSubject: '',
            editorHtml: '',
            sort: [{field: "SentDate", dir: "asc"}],
        }

        this.editor = React.createRef();

        this.requestNotices = this.requestNotices.bind(this);
        this.sortChange = this.sortChange.bind(this);
        this.SendNotice = this.SendNotice.bind(this);
        this.SendMobileNotice = this.SendMobileNotice.bind(this);
        this.ClearNotices = this.ClearNotices.bind(this);
        const preloadNoticeData = this.preloadNoticeData.bind(this);
        this.CommandCell = MySubjectCell(preloadNoticeData);
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="Notices" />
            <div className="row">
                <div className="col">
                    <h1>Notices</h1>
                </div>
                <div className="col">
                    <button type="button" className="btn btn-primary float-right" data-toggle="modal" data-target=".notice-modal" onClick={this.ClearNotices}>Send Email</button>
                    <button type="button" className="btn btn-primary float-right" data-toggle="modal" data-target=".mobile-modal" onClick={this.ClearNotices} style={{ marginRight: "10px" }}>Send Mobile Notification</button>
                    <div id="emailModal" className="modal fade notice-modal" tabIndex={-1} role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Send Email</h4>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <h5>Subject</h5>
                                    <span className="k-form-field">
                                        <input
                                            className="form-control input-group wide"
                                            type="text"
                                            name="Subject"
                                            placeholder="Subject"
                                            value={this.state.NoticeSubject}
                                            onChange={(e) => this.setState({ NoticeSubject: e.target.value })}
                                        />
                                    </span>
                                    <br/>
                                    <h5>Message</h5>
                                    <Editor
                                        className="bg-light"
                                        ref={this.editor}
                                        tools={[
                                            [ Bold, Italic, Underline ],
                                            [ Undo, Redo ],
                                            [ Link, Unlink ],
                                            [ AlignLeft, AlignCenter, AlignRight ],
                                            [ OrderedList, UnorderedList, Indent, Outdent ]
                                        ]}
                                        contentStyle={{ height: 320 }}
                                        defaultContent="Type email here..."
                                    />
                                    <p>*Notice will be sent to all active email accounts.</p>
                                    <br/>
                                    <button type="button" className="btn btn-primary float-right" onClick={this.SendNotice}>Send Email</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="mobileModal" className="modal fade mobile-modal" tabIndex={-1} role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Send Mobile Notification</h4>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <h5>Subject</h5>
                                    <span className="k-form-field">
                                        <input
                                            className="form-control input-group wide"
                                            type="text"
                                            name="Subject"
                                            placeholder="Subject"
                                            maxLength={100}
                                            value={this.state.MobileSubject}
                                            onChange={(e) => this.setState({ MobileSubject: e.target.value })}
                                        />
                                    </span>
                                    <br/>
                                    <h5>Message</h5>
                                    <span className="k-form-field">
                                        <input
                                            className="form-control input-group wide"
                                            type="text"
                                            name="Body"
                                            placeholder="Type your message here..."
                                            maxLength={140}
                                            value={this.state.MobileBody}
                                            onChange={(e) => this.setState({ MobileBody: e.target.value })}
                                        />
                                    </span>
                                    <p>*Notice will be sent to all active mobile devices.</p>
                                    <br/>
                                    <button type="button" className="btn btn-primary float-right" onClick={this.SendMobileNotice}>Send Mobile Notification</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            {this.state.Notices.length !== 0 && <React.Fragment>
                <Grid data={this.state.Notices}
                    sortable={{
                        allowUnsort: true
                    }}
                    sort={this.state.sort}
                    onSortChange={this.sortChange}
                    pageable={{
                        buttonCount: 0,
                        info: true,
                        type: 'numeric',
                        pageSizes: false,
                        previousNext: false
                    }}
                    skip={0}
                    take={this.state.Notices.length}
                    total={this.state.Notices.length}
                >
                    <Column field="Subject" title="Subject" cell={this.CommandCell} />
                    <Column field="SentBy" title="Sent By" cell={SentByCell} />
                    <Column field="SentDate" title="Sent Date" cell={SentDateCell} />
                    <Column field="Method" title="Method" cell={MethodCell} />
                </Grid>
            </React.Fragment>}
            {this.state.Notices.length === 0 && <h4 className="text-center">No Notices Sent.</h4>}
        </React.Fragment>
    }

    private sortChange(event: GridSortChangeEvent) {
        this.setState({
            sort: event.sort,
            Notices: orderBy(this.state.Notices, event.sort)
        });
    }

    private SendNotice(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();

        if (!this.state.NoticeSubject) {
            alert("Please enter a subject!");
            return;
        }

        if (confirm(`Are you sure you want to send this notice?`)) {

            const view = this.editor.current.view;

            const data = {
                Subject: this.state.NoticeSubject,
                Body: EditorUtils.getHtml(view.state),
                FacilityId: localStorage.getItem("FACILITY_ID") || 0
            }

            fetchApi(`api/Notice/Send`, data, 'POST')
                .then(() => {
                    $("#emailModal").modal('hide');
                    this.requestNotices();
                })
                .catch(() => alert("Failed to send!"));
        }
    }

    private SendMobileNotice(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();

        if (!this.state.MobileSubject) {
            alert("Please enter a subject!");
            return;
        }

        if (confirm(`Are you sure you want to send this notice?`)) {
            const data = {
                Title: this.state.MobileSubject,
                Body: this.state.MobileBody,
                FacilityId: localStorage.getItem("FACILITY_ID") || 0
            }

            fetchApi(`api/Notice/SendMobile`, data, 'POST')
                .then(() => {
                    $("#mobileModal").modal('hide');
                    this.requestNotices();
                })
                .catch(() => alert("Failed to send!"));
        }
    }

    public preloadNoticeData(subject: string, body: string, method: string) {
        if (method === "Email") {
            this.setState({ NoticeSubject: subject });
            if (this.editor.current) {
                EditorUtils.setHtml(this.editor.current.view, body);
            }
        } else {
            this.setState({ MobileSubject: subject, MobileBody: body });
        }
    }

    private ClearNotices() {
        this.setState({
            MobileBody: '',
            MobileSubject: '',
            NoticeSubject: ''
        });
        if (this.editor.current) {
            EditorUtils.setHtml(this.editor.current.view, '');
        }
    }

    public componentDidMount() {
        this.requestNotices();
    }

    public requestNotices() {
        fetchApi(`api/Notice/List`, {}, "GET")
            .then((data: NoticeData[] ) => {
                data.map(x => { x.SentDate = moment.utc(x.SentDate).toDate() })
                this.setState({ Notices: data });
            });
    }
}
